import {
  clearMsalAppSessionOnly as clearMsalAppSessionOnlyLib,
  createMsalPublicClientApplication,
  getMsalScopes as getMsalScopesLib,
} from '@ecrm-msal'
import { environment } from './environment'

export const msalInstance = createMsalPublicClientApplication({
  clientId: environment.msalConfig.clientId,
  authorityUrl: environment.msalConfig.authorityUrl,
})

export function getMsalScopes(): string[] {
  return getMsalScopesLib(environment.msalConfig.msalScope)
}

export async function clearMsalAppSessionOnly(): Promise<void> {
  return clearMsalAppSessionOnlyLib(msalInstance)
}
